module.exports = __webpack_public_path__ + "fonts/ralewaythin.ae0612b.woff2";